'use client';

import { MessageBox, Typography } from '@wishket/design-system';

import { useProfile } from '@/shared/hooks';
import { Skeleton } from '@/shared/Components';
import { useAuthorQuery } from '@/entities/author';

interface AuthorDetailMessageBoxProps {
  urlIdentifier: string;
}

const AuthorDetailMessageBoxSkeleton = () => {
  return <Skeleton className="hidden h-[218px] desktop:block" />;
};

const AuthorDetailMessageBox = ({
  urlIdentifier,
}: AuthorDetailMessageBoxProps) => {
  const { profile, isLoading: isProfileLoading } = useProfile();
  const { isLoading } = useAuthorQuery({ urlIdentifier });

  const isIdentifying = profile && profile.authorIdentifier === undefined;
  const isMine = profile?.authorIdentifier === urlIdentifier;

  const messageBoxIcon = isMine ? 'service' : 'write';
  const messageBoxTitle = isMine
    ? '작가 프로필을 입력하고 커리어를 소개해 보세요.'
    : '지금 보고 있는 작가의 최신 콘텐츠를 놓치지 마세요!';

  if (isLoading || isProfileLoading || isIdentifying)
    return <AuthorDetailMessageBoxSkeleton />;

  return (
    <MessageBox icon={messageBoxIcon} title={messageBoxTitle}>
      {isMine ? (
        <Typography variant="body1" className="text-gray-600">
          프로필을 입력하면 콘텐츠 신뢰도를 높일 수 있어요.
        </Typography>
      ) : (
        <Typography variant="body1" className="text-gray-600">
          <span className="font-medium">[알림 받기]</span>를 누르고 이메일로
          발행 소식을 받아보세요.
        </Typography>
      )}
    </MessageBox>
  );
};

export default AuthorDetailMessageBox;
